import { isOperand, Comparator, OperatorType } from './types.js';
export const evaluateOperand = (operand, elementAnswers) => {
    const element = elementAnswers.find((a) => a.field === operand.field);
    if (!element || element.answer === undefined)
        return operand.matcher.comparator !== Comparator.is;
    if (Array.isArray(element.answer)) {
        return operand.matcher.comparator === Comparator.is
            ? element.answer.includes(operand.matcher.match)
            : !element.answer.includes(operand.matcher.match);
    }
    else {
        return operand.matcher.comparator === Comparator.is
            ? element.answer === operand.matcher.match
            : element.answer !== operand.matcher.match;
    }
};
export const evaluateOperator = (operator, elementAnswers) => {
    if (operator.type === OperatorType.or) {
        return operator.conditions.some((condition) => {
            if (isOperand(condition)) {
                return evaluateOperand(condition, elementAnswers);
            }
            else {
                return evaluateOperator(condition, elementAnswers);
            }
        });
    }
    throw new Error(`Unsupported operator type: ${operator.type}`);
};
